import ChatRounded from '@mui/icons-material/ChatRounded';
import { Badge, IconButton } from '@mui/material';
import { useCallback } from 'react';
import { useChatContext } from '../../../../modules/chat/contexts/chat/chat.context';
import { useChatModalContext } from '../../../../modules/chat/contexts/chatModal/ChatModal.context';
import { useOpenChatButtonStyles } from './openChatButton.styles';

export const BUTTON_TO_OPEN_CHAT_ID = 'open-chat-button';

const OpenChatButton = () => {
  const { classes } = useOpenChatButtonStyles();

  const { open } = useChatModalContext();
  const { getTotalUnreadMessagesCount } = useChatContext();

  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    open(event.currentTarget);
  }, []);

  return (
    <Badge
      overlap="rectangular"
      badgeContent={getTotalUnreadMessagesCount()}
      classes={{ anchorOriginTopRightRectangular: classes.anchorOriginTopRightRectangle }}
      color="primary"
    >
      <IconButton id={BUTTON_TO_OPEN_CHAT_ID} size="small" onClick={handleClick}>
        <ChatRounded sx={{ color: 'action.active' }} />
      </IconButton>
    </Badge>
  );
};

export default OpenChatButton;
